// extracted by mini-css-extract-plugin
export default {"root":"AddOnPage_root__CbXva","header":"AddOnPage_header__yUloM","reducedHeight":"AddOnPage_reducedHeight__Rqbp6"};